export default __webpack_public_path__ + "static/media/populations.c5bfc09b.png";